import { ACTION_SET_QUERY_PAGEVIEWS, ACTION_SET_QUERY_TOP_POSTS, ACTION_SET_QUERY_RESULT } from "../action";


const reduceQuery = (state = {}, action) =>{
	switch (action.type) {
		case ACTION_SET_QUERY_RESULT:{
			return {
				...state,
				[action.payload.id]: action.payload.data
			}
		}
		case ACTION_SET_QUERY_PAGEVIEWS:
			return{
				...state,
				pageviews: action.payload,
			}
		case ACTION_SET_QUERY_TOP_POSTS:
			return {
				...state,
				top_posts: action.payload,
			};
	}
	return state;
};

export default reduceQuery;